/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vivid_Formal_Clownfish_ArriveInputs */

const en_vivid_formal_clownfish_arrive = /** @type {(inputs: Vivid_Formal_Clownfish_ArriveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Templates`)
};

const de_vivid_formal_clownfish_arrive = /** @type {(inputs: Vivid_Formal_Clownfish_ArriveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorlagen`)
};

/**
* | output |
* | --- |
* | "Templates" |
*
* @param {Vivid_Formal_Clownfish_ArriveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const vivid_formal_clownfish_arrive = /** @type {((inputs?: Vivid_Formal_Clownfish_ArriveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vivid_Formal_Clownfish_ArriveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vivid_formal_clownfish_arrive(inputs)
	return de_vivid_formal_clownfish_arrive(inputs)
});